import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/smc/new.png'


const _withScopeId = n => (_pushScopeId("data-v-6e160232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap of-hd" }
const _hoisted_2 = { class: "auto-width flex-ter-bwn rel" }
const _hoisted_3 = { class: "flex-ter" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex-ter" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-gongzuotai",
  style: {"font-size":"13px","margin-right":"4px","display":"inline-block","vertical-align":"bottom"}
}, null, -1))
const _hoisted_8 = { id: "cartBtn" }
const _hoisted_9 = { class: "user rel" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_12 = { class: "flex-center" }
const _hoisted_13 = { class: "top" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "rate-tip" }
const _hoisted_17 = {
  key: 0,
  class: "rate-tip-content"
}
const _hoisted_18 = { class: "rate-bg mt-12px flex-item-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"21px","margin-right":"4px"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/country/flag_JP_tab.png",
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "rel flex" }
const _hoisted_21 = {
  key: 0,
  class: "rateTag flex-cen-ter"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "rate-bg mt-8px flex-item-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"21px","margin-right":"4px"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/country/KoreaSquareIcon@3x.png",
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "rel flex" }
const _hoisted_26 = {
  key: 0,
  class: "rateTag flex-cen-ter"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "station-time" }
const _hoisted_29 = {
  key: 1,
  class: "rate-tip-content"
}
const _hoisted_30 = { class: "rel flex" }
const _hoisted_31 = {
  key: 0,
  class: "rateTag flex-cen-ter"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "station-time" }
const _hoisted_34 = {
  key: 2,
  class: "rate-tip-content"
}
const _hoisted_35 = { class: "rel flex" }
const _hoisted_36 = { class: "station-time" }

import { computed, watch, ref, onMounted, onBeforeUnmount } from 'vue'
import { getSmcBlackApi } from '@/apis/smc'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import dayjs from 'dayjs'
// import HelpDropdown from '../common/HelpDropdown.vue'
// import CartDropdown from '../common/CartDropdown.vue'
import UserPopover from './UserPopover.vue'
import TogglePlat from './TogglePlat.vue'
import ToggleShop from './ToggleShop.vue'
import { useRtfix, usePlat, isJA, isKO, useSite2Code, isJK, isEN, isMultiStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { rate, floatingRate, floatExchangeRate, getCountryCurrency, req, floatingRateKrw, floatExchangeRateKrw, rateKrw } from '@/util/useYan'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { bury } from '@/util/useBury'
import CartBtn from './CartBtn.vue'
import MessageBtn from './MessageBtn.vue'
import user from '@/router/modules/user'
import MemberLevel from './MemberCenter/MemberLevel.vue'
import MemberInvalid from './MemberCenter/MemberInvalid.vue'
import {
  Site, smc, siteMapAreaName,
  countries, CountriesEnum, findCountryNativeFlag
} from '@/common/const'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'
import { myShopIcons } from '@/store/modules/bussiness'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toUrl = ref('/signup')
// import floatRateTag from '@/assets/image/icon/rate/floatRateTag.jpg'

const store = useStore()
const route = useRoute()
const canUseSmc = ref(true)
if (route.query.code !== undefined && route.query.channel !== undefined) {
  toUrl.value = `/signup?code=${route.query.code}&channel=${route.query.channel}`
}
const floatRateTagJp = require('@/assets/image/icon/rate/tag_rate@2x.png')
const floatRateTagKo = require('@/assets/image/icon/rate/tag_FX_KRW.png')
const floatRateTagEn = require('@/assets/image/icon/rate/tag_FX_USD.png')

const floatRateTag = computed(() => {
  return isJA() ? floatRateTagJp : isKO() ? floatRateTagKo : isEN() ? floatRateTagEn : ''
})

const upBuryingUserCenter = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'workbench'
    }
  })
  if (!store.getters.isLogin) {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        source: 'workbench',
        position: 'login'
      }
    })
  }
}

const list = computed({
  get: () => store.state.toolbar.list,
  set: (v) => store.commit('toolbar/list', v)
})

watch(
  list,
  (v) => {
    store.commit('toolbar/list', v)
  },
  { deep: true }
)

const jump = (url: any) => window.open(url)

const jumptoSmc = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'promotion'
    }
  })
  confirmLoginWithNoCurShop(
    async () => (location.href = location.origin + smc.getUrl()), () => {
      taTrack({
        event: TaEvent.PUPUP_WINDOW,
        value: {
          source: 'promotion',
          position: 'login'
        }
      })
    }
  )
}
// 检测用户是否为黑名单用户
watch(() => store.getters?.user?.mainCustomerId, (val) => {
  if (!val) return
  getSmcBlackApi().then((res) => {
    canUseSmc.value = !res.data
  })
}, {
  immediate: true
})
// // TODO：开发测试跳转推广联盟。待删
// const jumptoSmc = () => confirmLoginWithNoCurShop(async () => {
//   const payload = {
//     'production_route/token': localStorage.getItem('development_route/token'),
//     'production_route/curShop': localStorage.getItem('development_route/curShop')
//   }

//   let jumpStr = `http://10.8.0.70:3666${smc.url}`

//   for (const key in payload) {
//     if (Object.prototype.hasOwnProperty.call(payload, key)) {
//       const value = payload[key]
//       jumpStr += `&${key}=${value}`
//     }
//   }

//   location.href = jumpStr
// })

const getFloatingRate = (floatingRate: number) => {
  if (!isEN()) {
    return Math.floor(floatingRate * 100) / 100
  } else {
    return Math.round(floatingRate * 10000) / 10000
  }
}

watch(() => store.getters.site, (value) => {
  req()
}, {
  immediate: true
})

const timeRef = ref<any>(null)
const stationNmae = ref<string | undefined>('')
const currentCountry = ref('')
const currentDate = ref('')

function formatTimeZone(time: any, offset: any) {
  var d = new Date(time) // 创建一个Date对象 time时间 offset 时区  中国为  8
  var localTime = d.getTime()
  var localOffset = d.getTimezoneOffset() * 60000 // 获得当地时间偏移的毫秒数
  var utc = localTime + localOffset // utc即GMT时间
  var wishTime = utc + (3600000 * offset)
  return new Date(wishTime)
}

const getCurrentUserShowTime = () => {
  if (isJA()) {
    stationNmae.value = siteMapAreaName.get(Site.JA)
  } else if (isKO()) {
    stationNmae.value = siteMapAreaName.get(Site.KO)
  }
  if (isJK()) {
    currentDate.value = dayjs(`${formatTimeZone(dayjs(new Date()), 9)}`).format('YYYY/MM/DD HH:mm:ss')
  } else {
    const customerUtcTimeZone = store.getters.user?.utcTimeZone ? Number(store.getters.user?.utcTimeZone?.replace('UTC', '')) : (0 - new Date().getTimezoneOffset() / 60)
    stationNmae.value = siteMapAreaName.get(Site.EN) + ' ' + (customerUtcTimeZone >= 0 ? `+${customerUtcTimeZone}` : String(customerUtcTimeZone))
    if (customerUtcTimeZone || customerUtcTimeZone === 0) {
      currentDate.value = dayjs(formatTimeZone(dayjs(new Date()), Number(customerUtcTimeZone))).format('YYYY/MM/DD HH:mm:ss')
    }
  }
}

onMounted(() => {
  // 获取当前用户显示时间
  getCurrentUserShowTime()

  if (!timeRef.value) {
    timeRef.value = setInterval(() => {
      getCurrentUserShowTime()
    }, 1000)
  }
})

onBeforeUnmount(() => {
  if (timeRef.value) {
    clearInterval(timeRef.value)
  }
})

// 根据语言获取当前国家
const initFormText = () => {
  currentCountry.value = (isJA() || isKO()) ? useSite2Code() : (localStorage.getItem('countryKey') || countries.find((item) => item.navigatorLang.includes(navigator.language))?.key || CountriesEnum.other)
}

initFormText()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_main = _resolveDirective("main")!

  return (_openBlock(), _createElementBlock("div", {
    id: "tool-bar",
    class: "abs flex-bwn box-lg-shadow",
    key: _unref(route).name?.toString()
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)('ALL_Click_LOGO'))),
            to: "/"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "headlogo",
                src: _unref(isJA)() ? 'https://static-jp.theckb.com/static-asset/client/homelogo_w.png' : 'https://static-s.theckb.com/BusinessMarket/Client/homelogo_w.png',
                alt: ""
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (canUseSmc.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "smc cart-btn",
                onClick: jumptoSmc
              }, [
                _hoisted_6,
                _createVNode(SvgIcon, {
                  class: "useSite2Station",
                  name: "推广"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('推广联盟')), 1)
              ], 512)), [
                [_directive_main]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_unref(store).getters.isLogin)
              ? (_openBlock(), _createBlock(MemberLevel, { key: 0 }))
              : _createCommentVNode("", true),
            (!_unref(store).getters.isLogin)
              ? (_openBlock(), _createBlock(MemberInvalid, { key: 1 }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", { onClick: upBuryingUserCenter }, [
            _createVNode(_component_router_link, {
              class: "ml_30 mr_30 light",
              to: _unref(useRtfix)('UserCenter'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(bury)('ALL_Click_Workbench')))
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(_toDisplayString(_unref(t)('工作台')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(CartBtn, { class: "mr_35 light cart-btn" })
          ]),
          _createElementVNode("div", _hoisted_9, [
            (!_unref(store).getters.isLogin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("img", {
                    src: _unref(isJA)() ? 'https://static-jp.theckb.com/static-asset/client/ckbuser.png?t=2024' : 'https://static-s.theckb.com/BusinessMarket/Client/ckbuser.png?t=2024',
                    style: {"width":"16px","height":"16px","position":"absolute","top":"-2px","left":"-19px"},
                    alt: ""
                  }, null, 8, _hoisted_10),
                  _createVNode(_component_router_link, {
                    onClick: _cache[2] || (_cache[2] = () => {
                _unref(bury)('ALL_Click_LogIn')
                _unref(taTrack)({
                  event: _unref(TaEvent).BTN_CLICK,
                  value: {
                    position: 'login'
                  }
                })
              }),
                    class: "light",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('请登录')), 1)
                    ]),
                    _: 1
                  }),
                  _hoisted_11,
                  _createVNode(_component_router_link, {
                    onClick: _cache[3] || (_cache[3] = () => {
                _unref(bury)('ALL_Click_Register')
                _unref(taTrack)({
                  event: _unref(TaEvent).BTN_CLICK,
                  value: {
                    position: 'register'
                  }
                })
              }),
                    class: "light",
                    to: "/signup"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('免费注册')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(UserPopover, { key: 1 }))
          ]),
          (_unref(store).getters.isLogin)
            ? (_openBlock(), _createBlock(ToggleShop, { key: 1 }))
            : _createCommentVNode("", true),
          _createVNode(MessageBtn, { class: "ml_30 mr_5 light cart-btn" }),
          _createVNode(_component_el_popover, {
            width: _unref(isEN)() ? 300 : _unref(isKO)() ? 280 : 300,
            placement: "bottom",
            "hide-after": 50,
            offset: 12
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", {
                class: "rate light",
                onClick: _cache[4] || (_cache[4] = () => {
                _unref(bury)('ALL_Click_Rate');
                if (_unref(isJA)()) {
                  jump('http://www.murc-kawasesouba.jp/fx/index.php');
                }
              })
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (_unref(store).getters.user && _unref(store).getters.isLogin)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(findCountryNativeFlag)(_unref(store).getters?.user?.nationCode),
                          class: "country-img"
                        }, null, 8, _hoisted_14))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _unref(findCountryNativeFlag)(currentCountry.value),
                          class: "country-img"
                        }, null, 8, _hoisted_15))
                  ]),
                  _createElementVNode("div", null, " CNY1=" + _toDisplayString(_unref(getCountryCurrency)()) + _toDisplayString(getFloatingRate(_unref(floatingRate))), 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createTextVNode(" CNY1=" + _toDisplayString(_unref(getCountryCurrency)()) + _toDisplayString(getFloatingRate(_unref(floatingRate))), 1)
                      ]),
                      _createElementVNode("div", null, " 三菱UFJ銀行TTSレート：" + _toDisplayString(_unref(rate)), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, " THE CKBの対応レート：" + _toDisplayString(_unref(floatingRate)), 1),
                        (_unref(floatExchangeRate) < 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("img", {
                                src: _unref(floatRateTag),
                                alt: ""
                              }, null, 8, _hoisted_22)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(isMultiStore)() && _unref(store).getters.isLogin)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _createTextVNode(" KRW1=" + _toDisplayString(_unref(getCountryCurrency)()) + _toDisplayString(_unref(floatingRateKrw)), 1)
                            ]),
                            _createElementVNode("div", null, " ハナ銀行TTSレート：" + _toDisplayString(_unref(rateKrw)), 1),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", null, " THE CKBの対応レート：" + _toDisplayString(_unref(floatingRateKrw)), 1),
                              (_unref(floatExchangeRateKrw) < 0.007)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("img", {
                                      src: _unref(floatRateTag),
                                      alt: ""
                                    }, null, 8, _hoisted_27)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(stationNmae.value) + " " + _toDisplayString(currentDate.value), 1)
                    ]))
                  : (_unref(isKO)())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", null, " 하나은행 고시환율：" + _toDisplayString(getFloatingRate(_unref(rate))), 1),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", null, " THE CKB 구매대행 환율：" + _toDisplayString(getFloatingRate(_unref(floatingRate))), 1),
                          (_unref(floatExchangeRate) < 10)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("img", {
                                  src: _unref(floatRateTag),
                                  alt: ""
                                }, null, 8, _hoisted_32)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(stationNmae.value) + " " + _toDisplayString(currentDate.value), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", null, " BOC Exchange Rate：" + _toDisplayString(getFloatingRate(_unref(rate))), 1),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", null, " THE CKB Exchange Rate：" + _toDisplayString(getFloatingRate(_unref(floatingRate))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(stationNmae.value) + " " + _toDisplayString(currentDate.value), 1)
                      ]))
              ])
            ]),
            _: 1
          }, 8, ["width"]),
          _createVNode(TogglePlat, { class: "ml_30 toggle-plat" })
        ])
      ])
    ])
  ]))
}
}

})